import { render, staticRenderFns } from "./VehicleAnnualReview.vue?vue&type=template&id=c88af364&scoped=true&"
import script from "./VehicleAnnualReview.vue?vue&type=script&lang=js&"
export * from "./VehicleAnnualReview.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAnnualReview.vue?vue&type=style&index=0&id=c88af364&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88af364",
  null
  
)

export default component.exports